
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
  width:100%;
}

ul{
  list-style:none;
  margin:0;
  padding:0;
}

.capabilities-block{
  border-image:conic-gradient(var(--brand-primary-4) 0 0) fill 0 //0 100vmax;;
  padding-block:1.25rem;
  width:100%;
}

@media (min-width: 768px){

.capabilities-block{
    border-image:none;
    padding:1.5rem;
    background-color:var(--brand-primary-4)
}
  }

.capabilities-block--main-item{
  width:100%;
}

.capabilities-block--main-item:nth-of-type(2n){
  margin-top:3rem !important;
}

.capabilities-block--main-item-label{
  font-size:var(--fs-h4);
  font-weight:var(--fw-medium);
  font-family:var(--ff-dmsans);
  margin-top:0;
  margin-bottom:1rem;
  padding-left:0.25rem;
}

.capabilities-block--list{
  padding-bottom:1rem;
  overflow:hidden;
  transition:var(--transition);
  height:var(--closed-height);
}

.capabilities-block--list.open{
    height:var(--open-height) !important;
  }

.capabilities-block--list li:first-of-type{
    padding-top:0.25rem !important;
  }

.capabilities-block--link{
  display:inline-flex;
  position:relative;
  padding:0.25rem 0;
  font-size:var(--fs-lg);
  font-family:var(--ff-dmsans);
  color:var(--brand-primary-2);
  font-weight:var(--fw-bold);
  text-decoration:none;
  border-bottom:2px solid transparent;
}

.capabilities-block--link:hover{
    border-bottom:2px solid var(--brand-primary-2);
  }

.capabilities-block--link.hidden{
    display:none;
  }

.capabilities-block--button{
  display:flex;
  width:100%;
  justify-content:space-between;
  border:unset;
  font-family:var(--ff-dmsans);
  background:transparent;
  font-size:1.5rem;
  padding:0.75rem 0 0.75rem 0.25rem;
  cursor:pointer;
  border-top:1px solid var(--brand-neutral-gray-800);
}

.capabilities-block--item{
  padding-left:0.25rem;
}
`;